import { ApiResult } from 'src/Libs/api'

import { ShopAuthFetchWithResponse } from '../types'
import { StatusCodes } from '@e3dc-react/shell/Libs/http-status-codes'
import { BasicSystemResponseModel } from '../models/basic-system.model'
import { SystemConfigurationComponentsResponse } from '../models/system-configuration-components.model'
import { handleFetchError } from 'src/Libs/api/utils'

/*
 * This endpoint gets the Basic System Configurators (Products).
 */
export const fetchQntmBasicSystemConfiguration = async (shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<BasicSystemResponseModel>> => {
  const payload = {
    includes: {
      e3dc_connector_quantum_system_configurator: ['id', 'productionGroup', 'name', 'mainImage', 'translated', 'fixFlex', 'description'],
      media: ['url', 'thumbnails'],
      media_thumbnail: ['width', 'height', 'url'],
    },
  }

  try {
    const response = await shopFetch<BasicSystemResponseModel>({
      path: 'e3dc/quantum-system-configurator',
      method: 'GET',
      criteria: payload,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<BasicSystemResponseModel>(response.data, true)
    }

    return new ApiResult<BasicSystemResponseModel>(null)
  } catch (error) {
    return handleFetchError<BasicSystemResponseModel>(error)
  }
}

/*
 * This endpoint will take all the Products (Components) based on the Basic System Configurator ID
 */
export const fetchQntmSystemConfigurationComponents = async (
  configuratorId: string,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<SystemConfigurationComponentsResponse>> => {
  const payload = {
    associations: {
      components: {
        associations: {
          products: {
            associations: {
              product: {
                associations: {
                  media: {
                    associations: {
                      media: {
                        associations: {
                          thumbnails: {},
                        },
                      },
                    },
                  },
                  cover: {
                    associations: {
                      media: {
                        associations: {
                          thumbnails: {},
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    includes: {
      e3dc_connector_quantum_system_configurator: [
        'id',
        'productionGroup',
        'name',
        'mainImage',
        'translated',
        'components',
        'powerMeterExternal',
        'powerMeterFarming',
        'powerMeterHouseConnection',
        'warrantyExtensions',
        'em360Product',
      ],
      media: ['url', 'thumbnails'],
      media_thumbnail: ['width', 'height', 'url'],
      product_media: ['media', 'url', 'thumbnails'],
      e3dc_connector_system_configurator_component: ['products', 'mandatory', 'name', 'translated', 'id', 'position'],
      product: [
        'e3dcData',
        'media',
        'translated',
        'id',
        'calculatedPrice',
        'name',
        'e3dcPriceApplied',
        'cover',
        'minPurchase',
        'maxPurchase',
        'e3dcAvailability',
        'customFields',
      ],
      calculated_price: ['listPrice', 'unitPrice'],
      e3dc_connector_system_configurator_component_product: ['position', 'product'],
    },
  }
  try {
    const response = await shopFetch<SystemConfigurationComponentsResponse>({
      path: `e3dc/quantum-system-configurator/${configuratorId}`,
      method: 'GET',
      criteria: payload,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<SystemConfigurationComponentsResponse>(response.data, true)
    }

    return new ApiResult<SystemConfigurationComponentsResponse>(null)
  } catch (error) {
    return handleFetchError<SystemConfigurationComponentsResponse>(error)
  }
}

/*
 * This endpoint will return a System Configurator by the ID
 */
export const fetchQntmSingleSystemConfiguration = async (
  configuratorId: string,
  shopFetch: ShopAuthFetchWithResponse
): Promise<ApiResult<BasicSystemResponseModel>> => {
  const payload = {
    includes: {
      e3dc_connector_quantum_system_configurator: [
        'id',
        'em360Product',
        'warrantyExtensions',
        'productionGroup',
        'name',
        'mainImage',
        'translated',
        'fixFlex',
      ],
      media: ['url', 'thumbnails'],
      media_thumbnail: ['width', 'height', 'url'],
    },
  }

  try {
    const response = await shopFetch<BasicSystemResponseModel>({
      path: `e3dc/quantum-system-configurator/${configuratorId}`,
      method: 'GET',
      criteria: payload,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<BasicSystemResponseModel>(response.data, true)
    }

    return new ApiResult<BasicSystemResponseModel>(null)
  } catch (error) {
    return handleFetchError<BasicSystemResponseModel>(error)
  }
}
